//Des variables
const state = () => ({
  _id       : "",
  travauxHT : 0,
  honoHT    : 0,
})

//Comment ces variables changent
const mutations = {
  setId(state, val){
    state._id = val;
  },
  setTravauxHT(state, val){
    state.travauxHT = val;
  },
  setHonoHT(state, val){
    state.honoHT = val;
  },
}

//Combo de plusieurs mutations
const actions = {

}

//Etat d'un state retravaillé (mise en forme, concaténation, etc.)
const getters = {

}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}